import { type Component } from 'solid-js'
import Logo from '../../assets/images/chorus-logo.svg'

const Footer: Component = () => {
  return (
    <div class="bg-gray-50 border-t border-gray-200">
      <div class="max-w-7xl mx-auto w-full flex flex-col text-center sm:flex-row sm:text-left items-center justify-between gap-8 p-8 py-12">
        <div class="flex justify-center items-center">
          <img src={Logo} alt="Chorus" class="h-5" />
        </div>
        <div class="text-sm text-gray-500">
          <div>
            <span class="text-gray-500 text-sm">© 2026 chorus. All rights reserved.</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
